import ComponentElement from 'components/component-element';

/**
 * Класс обработчик выбора количества звёзд
 * @param {Element} $element Контейнер для звёзд
 */
function StarsInput($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$element.insertAdjacentHTML('beforeend',
        `<div class="Stars-input">
            <input type="hidden" name="${this.options.name}" value="${this.options.value}">
            <div class="Stars-input__container">
                ${new Array(this.options.maxValue).fill(1).map((v, index) => (
                    `<div class="Stars-input__star js-star"></div>`
                )).join('')}
            </div>
        </div>`
    );

    this.$input = this.$element.querySelector('input');
    this.$stars = this.$element.querySelectorAll('.js-star');

    // клик по звезде
    this.$stars.forEach(($star, index) => {
        $star.addEventListener('click', e => {
            const value = index + 1;

            // повторное нажатие обнуляет value
            if (this.getValue() == value && this.options.minValue === 0) {
                this.setValue(0);
                return;
            }

            this.setValue(value);
        });
    });

    this.setValue(this.options.value);
}

StarsInput.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(StarsInput.prototype, 'constructor', {
    value: StarsInput,
    enumerable: false,
    writable: true,
});

StarsInput.prototype.setOptions = function(options) {
    ComponentElement.prototype.setOptions.call(this, Object.assign({
        value:    typeof this.$element.dataset.value    != 'undefined' ? parseInt(this.$element.dataset.value, 10)    :  5,
        maxValue: typeof this.$element.dataset.maxValue != 'undefined' ? parseInt(this.$element.dataset.maxValue, 10) :  5,
        minValue: typeof this.$element.dataset.minValue != 'undefined' ? parseInt(this.$element.dataset.minValue, 10) :  1,
        name:     typeof this.$element.dataset.name     != 'undefined' ? this.$element.dataset.name                   :  'stars',
    }, options));
}

StarsInput.prototype.getValue = function() {
    return parseInt(this.$input.value, 10);
}

/**
 * Установка значения количества звёзд
 * @param {Number} value Количество звёзд
 */
StarsInput.prototype.setValue = function(value) {
    value = Math.min(this.$stars.length, Math.max(0, parseInt(value, 10) || 0));

    for (let i = 0; i < this.$stars.length; ++i) {
        this.$stars[i].classList.toggle('is-active', i < value);
    }

    if (this.$input.value != value) {
        this.$input.value = value;
        this.emit('change', value);
    }
}

StarsInput.prototype.reset = function() {
    this.setValue(this.options.value);
}

export default StarsInput;
